import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';

export interface CleanStartSummary {
  remove: Record<string, number>;
  keep: { vehicles: { fleetNo: string; plate: string }[]; providers: string[]; places: string[] };
}

export interface CleanStartResult {
  deleted: Record<string, number>;
  filesRemoved: number;
  files: number;
  created: { role: string; email: string; fullName: string }[];
  failed: { role: string; email: string; message: string }[];
  driverId: string | null;
}

export interface CleanStartInput {
  confirm: string;
  password: string;
  ownerName?: string;
  accounts: { role: 'dispatcher' | 'accountant' | 'mechanic'; email: string; password: string }[];
  driver: boolean;
}

export function useCleanStartSummary(enabled: boolean) {
  return useQuery({
    queryKey: ['clean-start'],
    queryFn: () => api.get<CleanStartSummary>('/clean-start'),
    enabled,
  });
}

/** След изчистването всичко в паметта на офиса е остаряло — всичко се тегли наново. */
export function useCleanStart() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CleanStartInput) => api.post<CleanStartResult>('/clean-start', body),
    onSuccess: () => void qc.invalidateQueries(),
  });
}
